function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".hamburger_svg__cls-1{fill:none;stroke:#e5bb64;stroke-width:2px}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "hamburger_svg__Group_100",
  "data-name": "Group 100",
  transform: "translate(-332 -39.5)"
}, React.createElement("path", {
  id: "hamburger_svg__Line_129",
  d: "M0 0h20",
  className: "hamburger_svg__cls-1",
  "data-name": "Line 129",
  transform: "translate(334 44.5)"
}), React.createElement("path", {
  id: "hamburger_svg__Line_130",
  d: "M0 0h20",
  className: "hamburger_svg__cls-1",
  "data-name": "Line 130",
  transform: "translate(334 51.5)"
}), React.createElement("path", {
  id: "hamburger_svg__Line_131",
  d: "M0 0h20",
  className: "hamburger_svg__cls-1",
  "data-name": "Line 131",
  transform: "translate(334 58.5)"
}), React.createElement("path", {
  id: "hamburger_svg__Rectangle_193",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 193",
  transform: "translate(332 39.5)",
  fill: "none"
}));

var SvgHamburger = function SvgHamburger(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy0xLC5jbHMtMntmaWxsOm5vbmV9LmNscy0xe3N0cm9rZTojZTViYjY0O3N0cm9rZS13aWR0aDoycHh9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJHcm91cF8xMDAiIGRhdGEtbmFtZT0iR3JvdXAgMTAwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzMyIC0zOS41KSI+CiAgICAgICAgPHBhdGggaWQ9IkxpbmVfMTI5IiBkPSJNMCAwaDIwIiBjbGFzcz0iY2xzLTEiIGRhdGEtbmFtZT0iTGluZSAxMjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzNCA0NC41KSIvPgogICAgICAgIDxwYXRoIGlkPSJMaW5lXzEzMCIgZD0iTTAgMGgyMCIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IkxpbmUgMTMwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzQgNTEuNSkiLz4KICAgICAgICA8cGF0aCBpZD0iTGluZV8xMzEiIGQ9Ik0wIDBoMjAiIGNsYXNzPSJjbHMtMSIgZGF0YS1uYW1lPSJMaW5lIDEzMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzM0IDU4LjUpIi8+CiAgICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8xOTMiIGQ9Ik0wIDBoMjR2MjRIMHoiIGNsYXNzPSJjbHMtMiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTkzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzIgMzkuNSkiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgHamburger as ReactComponent };


//////////////////
// WEBPACK FOOTER
// /src/assets/img/hamburger.svg
// module id = 2144
// module chunks = 0